<script setup lang="ts">
import TableTutorSlotLog from './shift-control/TableTutorSlotLog.vue'
import { useTutorSlotLogStore } from '../model/tutor-slot-log/store'
import { useTutorSlotLogsApi } from '../api/tutor-slots/logs.hook'

defineOptions({
  name: 'DemosTutorSlotLogPage',
})

const store = useTutorSlotLogStore()

watch(
  () => [store.isSearchable, store.hasSearched, store.isLoading] as const,
  ([isSearchable, hasSearched, isLoading]) => {
    if (isSearchable && !hasSearched && !isLoading) {
      void useTutorSlotLogsApi()
    }
  },
  { immediate: true },
)
</script>

<template>
  <TableTutorSlotLog />
</template>
